import { render, staticRenderFns } from "./InitiateReviewPopup.vue?vue&type=template&id=acb440be&"
import script from "./InitiateReviewPopup.vue?vue&type=script&lang=js&"
export * from "./InitiateReviewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports